import { AgentDevice } from 'models/agent-device.model';
import { Page } from 'models/page';
import api from '../api/instance';

const nameSpace = '/settings/agent_devices';

const findAll = (query?, size?, page?, sort?, agentId?, provisioned?) => {
  provisioned =
    provisioned === true || provisioned === false ? provisioned : null;
  return api
    .get(nameSpace, {
      query,
      size,
      page,
      sort,
      agentId,
      provisioned,
    })
    .then((res) => new Page<AgentDevice>().deserialize(res, AgentDevice))
    .catch((e) => Promise.reject(e));
};

const getDevice = (deviceId: number) => {
  return api
    .get(`${nameSpace}/${deviceId}`)
    .then((res) => new AgentDevice().deserialize(res))
    .catch((e) => Promise.reject(e));
};

export const AgentDeviceService = {
  findAll,
  getDevice,
};
